module.exports = __webpack_public_path__ + "static/media/mars-awakens-10.70b4f82c.jpg";